import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { AuthService } from "app/core/auth.service";
import { FirebaseHelper } from "app/helpers/firebase.helper";
import { OnSiteSOP, sop } from "app/interfaces/client/on-site-sop.interface";
import { AppUser } from "app/interfaces/user.interface";
import { first, map } from "rxjs/operators";

@Injectable()
export class SopService {
    appUser: AppUser;
    constructor(
        private readonly authService: AuthService,
        private firestore: AngularFirestore
    ) {

        console.debug('UserService: instantiated');
    }

    async createSOP(clientKey: string, sop: sop[], version: number, enabled: boolean, updateVersion: boolean, id?: string): Promise<void> {
        var user = this.authService.appUser.userDetail;
        let changes = {
            clientKey: clientKey,
            sop: sop,
            version: version,
            enabled: enabled || false,
        };

        try {
            changes = FirebaseHelper.convertForFirebase(changes);
            const collectionRef = this.firestore.collection("sop");

            if (updateVersion && id) {
                // Update the existing document
                await collectionRef.doc(id).update(changes);
            } else {
                // Add a new document
                await collectionRef.add(changes);
            }
        } catch (error) {
            console.error("Error changing clients:", error);
            throw error;
        }
    }

    async getSopData(clientKey: string): Promise<OnSiteSOP> {
        try {
            const querys = this.firestore.collection('sop', ref =>
                ref.where('clientKey', '==', clientKey).orderBy('version', 'desc').limit(1)
            );
            const snapshots = await querys.get().toPromise();
            if (snapshots.docs.length > 0) {
                const highestVersionDoc = snapshots.docs[0];
                return { id: highestVersionDoc.id, ...highestVersionDoc.data() } as OnSiteSOP;
            }
        } catch (error) {
            console.error('Error fetching SOP data:', error);
            throw error;
        }
    }

}